import { MODULE_ROUTE } from "../../routers/module-router";

export type SidebarNavItem = {
  id: string;
  title: string;
  path: string;
  icon?: string; // emoji or icon key
  badge?: number | string;
  permissionCodes?: string[];
};

export type SidebarNavGroup = {
  id: string;
  title: string;
  items: SidebarNavItem[];
};

export const SIDEBAR_GROUPS: SidebarNavGroup[] = [
  {
    id: "overview",
    title: "TỔNG QUAN HỆ THỐNG",
    items: [
      {
        id: "dashboard",
        title: "Dashboard Tổng",
        path: MODULE_ROUTE.DASHBOARD,
        icon: "📊",
        permissionCodes: ["DASHBOARD_VIEW"],
      },
      // {
      //   id: "analytics",
      //   title: "Phân tích kinh doanh",
      //   path: "analytics",
      //   icon: "📈",
      //   permissionCodes: ["ANALYTICS_VIEW"],
      // },
      // {
      //   id: "realtime",
      //   title: "Giám sát real-time",
      //   path: "",
      //   icon: "📺",
      //   permissionCodes: ["REALTIME_VIEW"],
      // },
      // {
      //   id: "analytics",
      //   title: "Phân tích kinh doanh",
      //   path: "analytics",
      //   icon: "📈",
      //   permissionCodes: [],
      // },
      // {
      //   id: "realtime",
      //   title: "Giám sát real-time",
      //   path: "",
      //   icon: "📺",
      //   permissionCodes: [],
      // },
    ],
  },
  {
    id: "multi-store",
    title: "QUẢN LÝ CHI NHÁNH",
    items: [
      {
        id: "stores",
        title: "Danh sách chi nhánh",
        path: MODULE_ROUTE.BRANCH,
        icon: "🏢",
        permissionCodes: ["STORES_VIEW"],
      },
      {
        id: "transport-vehicles",
        title: "Quản lý xe vận chuyển",
        path: MODULE_ROUTE.TRANSPORT_VEHICLE,
        icon: "🚚",
        permissionCodes: ["TRANSPORT_VEHICLE_MANAGE"],
      },
      // {
      //   id: "store-performance",
      //   title: "Hiệu suất chi nhánh",
      //   path: "",
      //   icon: "📊",
      //   permissionCodes: [],
      // },
      // {
      //   id: "inter-store",
      //   title: "Chuyển đơn chi nhánh",
      //   path: "",
      //   icon: "🔄",
      //   permissionCodes: [],
      // },
      // {
      //   id: "store-settings",
      //   title: "Cấu hình chi nhánh",
      //   path: "",
      //   icon: "⚙️",
      //   permissionCodes: [],
      // },
    ],
  },
  {
    id: "orders",
    title: "QUẢN LÝ ĐƠN HÀNG",
    items: [
      // {
      //   id: "pos",
      //   title: "POS System",
      //   path: MODULE_ROUTE.POS_ORDER,
      //   icon: "🛒",
      //   permissionCodes: ["POS_VIEW"],
      // },
      {
        id: "create-order",
        title: "Đặt hàng",
        path: MODULE_ROUTE.CREATE_ORDER,
        icon: "➕",
        permissionCodes: ["POS_VIEW"],
      },
      {
        id: "orders",
        title: "Danh sách đơn hàng",
        path: MODULE_ROUTE.ORDER,
        icon: "📋",
        permissionCodes: ["ORDERS_VIEW"],
      },
      {
        id: "recurring-orders",
        title: "Đơn hàng định kỳ",
        path: MODULE_ROUTE.RECURRING_ORDERS,
        icon: "🔄",
        permissionCodes: ["RECURRING_ORDERS_VIEW"],
      },
      // {
      //   id: "order-tracking",
      //   title: "Theo dõi đơn hàng",
      //   path: "",
      //   icon: "🗺️",
      //   permissionCodes: [],
      // },
      // {
      //   id: "order-queue",
      //   title: "Hàng đợi xử lý",
      //   path: "",
      //   icon: "⏱️",
      //   badge: 12,
      //   permissionCodes: [],
      // },
      // {
      //   id: "bulk-orders",
      //   title: "Đơn hàng số lượng lớn",
      //   path: "",
      //   icon: "📦",
      //   permissionCodes: [],
      // },
    ],
  },
  {
    id: "operations",
    title: "THIẾT BỊ & LOẠI ĐỒ",
    items: [
      {
        id: "equipment",
        title: "Quản lý thiết bị",
        path: MODULE_ROUTE.EQUIPMENT,
        icon: "🏭",
        permissionCodes: ["EQUIPMENT_VIEW"],
      },
      {
        id: "clothing-categories",
        title: "Quản lý loại đồ",
        path: MODULE_ROUTE.CLOTHING_CATEGORIES,
        icon: "👕",
        permissionCodes: ["CLOTHING_CATEGORIES_VIEW"],
      },
    ],
  },
  {
    id: "services-pricing",
    title: "DỊCH VỤ & GIÁ CẢ",
    items: [
      {
        id: "units",
        title: "Đơn vị",
        path: MODULE_ROUTE.UNITS,
        icon: "📏",
        permissionCodes: ["SERVICE_TYPES_VIEW"],
      },
      {
        id: "service-types",
        title: "Sản phẩm dịch vụ",
        path: MODULE_ROUTE.SERVICE_TYPE_LIST,
        icon: "🧩",
        permissionCodes: ["SERVICE_TYPES_VIEW"],
      },
      // {
      //   id: "laundry-categories",
      //   title: "Danh mục sản phẩm",
      //   path: MODULE_ROUTE.SERVICES_LIST,
      //   icon: "🧼",
      //   permissionCodes: [],
      // },
      {
        id: "service-type-maps",
        title: "Nhóm dịch vụ",
        path: MODULE_ROUTE.SERVICE_MAP_LIST,
        icon: "🧾",
        permissionCodes: ["SERVICE_TYPE_MAPS_VIEW"],
      },
      {
        id: "service-addons",
        title: "Danh mục dịch vụ đi kèm",
        path: MODULE_ROUTE.SERVICE_ADDON_LIST,
        icon: "➕",
        permissionCodes: ["SERVICE_ADDONS_VIEW"],
      },
      {
        id: "customer-pricing",
        title: "Đơn giá riêng khách hàng",
        path: MODULE_ROUTE.CUSTOMER_PRICING,
        icon: "💲",
        permissionCodes: ["CUSTOMER_PRICING_VIEW"],
      },
      // {
      //   id: "wage-rates",
      //   title: "Đơn giá nhân viên",
      //   path: MODULE_ROUTE.WAGE_RATES,
      //   icon: "💰",
      //   permissionCodes: [],
      // },
    ],
  },
  {
    id: "customers",
    title: "KHÁCH HÀNG & LIÊN LẠC",
    items: [
      {
        id: "customers",
        title: "Quản lý khách hàng",
        path: MODULE_ROUTE.CUSTOMER,
        icon: "👥",
        permissionCodes: ["MANAGE_CUSTOMERS"],
      },
      // {
      //   id: "customer-segments",
      //   title: "Phân khúc khách hàng",
      //   path: "",
      //   icon: "🎯",
      //   permissionCodes: [],
      // },
      // {
      //   id: "loyalty-program",
      //   title: "Chương trình thân thiết",
      //   path: "",
      //   icon: "⭐",
      //   permissionCodes: [],
      // },
      // {
      //   id: "notifications",
      //   title: "Thông báo & SMS",
      //   path: "",
      //   icon: "📱",
      //   permissionCodes: [],
      // },
      // {
      //   id: "reviews",
      //   title: "Đánh giá & Phản hồi",
      //   path: "",
      //   icon: "💬",
      //   permissionCodes: [],
      // },
    ],
  },
  // {
  //   id: "delivery",
  //   title: "VẬN CHUYỂN & GIAO HÀNG",
  //   items: [
      // {
      //   id: "shippers",
      //   title: "Quản lý Tài xế giao hàng",
      //   path: MODULE_ROUTE.DRIVER,
      //   icon: "🚚",
      //   permissionCodes: ["MANAGE_DRIVERS"],
      // },
      // {
      //   id: "delivery-routes",
      //   title: "Tối ưu tuyến đường",
      //   path: "",
      //   icon: "🗺️",
      //   permissionCodes: [],
      // },
      // {
      //   id: "pickup-schedule",
      //   title: "Lịch trình pickup",
      //   path: "",
      //   icon: "📅",
      //   permissionCodes: [],
      // },
      // {
      //   id: "delivery-tracking",
      //   title: "Theo dõi giao hàng",
      //   path: "",
      //   icon: "📍",
      //   permissionCodes: [],
      // },
      // {
      //   id: "fleet-management",
      //   title: "Quản lý đội xe",
      //   path: "",
      //   icon: "🚐",
      //   permissionCodes: [],
      // },
  //   ],
  // },
  {
    id: "finance",
    title: "TÀI CHÍNH & KẾ TOÁN",
    items: [
      // {
      //   id: "finance",
      //   title: "Tổng quan tài chính",
      //   path: "",
      //   icon: "💰",
      //   permissionCodes: [],
      // },
      {
        id: "expenses",
        title: "Quản lý Thu Chi",
        path: MODULE_ROUTE.RECEIPT,
        icon: "📋",
        permissionCodes: ["RECEIPT_VIEW"],
      },
      {
        id: "payments",
        title: "Danh mục Thu Chi",
        path: MODULE_ROUTE.RECEIPT_CATEGORY,
        icon: "💳",
        permissionCodes: ["RECEIPT_CATEGORY_VIEW"],
      },
      {
        id: "invoicing",
        title: "Tài Khoản Kế Toán",
        path: MODULE_ROUTE.ACCOUNTING_ACCOUNT,
        icon: "💰",
        permissionCodes: ["ACCOUNTING_ACCOUNT_VIEW"],
      },
      {
        id: "driver-cash-ledger",
        title: "Sổ quỹ tài xế",
        path: MODULE_ROUTE.DRIVER_CASH_LEDGER,
        icon: "📒",
        permissionCodes: ["DRIVER_CASH_LEDGER_VIEW"],
      },
      {
        id: "customer-debt",
        title: "Công nợ khách hàng",
        path: MODULE_ROUTE.CUSTOMER_DEBT,
        icon: "📑",
        permissionCodes: ["CUSTOMER_DEBT_VIEW"],
      },
      {
        id: "bank-transfers",
        title: "Đối soát chuyển khoản",
        path: MODULE_ROUTE.BANK_TRANSFER,
        icon: "🏦",
        // Dùng chung quyền xem Thu Chi (BE kiểm cùng mã này) — chưa có mã quyền riêng cho đối soát.
        permissionCodes: ["RECEIPT_VIEW"],
      },
      // {
      //   id: "tax-management",
      //   title: "Quản lý thuế",
      //   path: "",
      //   icon: "📊",
      //   permissionCodes: [],
      // },
    ],
  },
  // {
    // id: "inventory",
    // title: "KHO & VẬT TƯ",
    // items: [
    //   {
    //     id: "inventory",
    //     title: "Quản lý kho",
    //     path: "",
    //     icon: "📦",
    //     permissionCodes: [],
    //   },
    //   {
    //     id: "supplies",
    //     title: "Vật tư tiêu hao",
    //     path: "",
    //     icon: "🧴",
    //     permissionCodes: [],
    //   },
    //   {
    //     id: "purchase-orders",
    //     title: "Đơn đặt hàng",
    //     path: "",
    //     icon: "🛒",
    //     permissionCodes: [],
    //   },
    //   {
    //     id: "vendors",
    //     title: "Quản lý nhà cung cấp",
    //     path: "",
    //     icon: "🏪",
    //     permissionCodes: [],
    //   },
    // ],
  // },
  {
    id: "hr",
    title: "NHÂN SỰ & NHÂN VIÊN",
    items: [
      {
        id: "user",
        title: "Quản lý nhân viên",
        path: MODULE_ROUTE.USER,
        icon: "👨‍💼",
        permissionCodes: ["MANAGE_EMPLOYEES"],
      },
      {
        id: "department",
        title: "Quản lý bộ phận",
        path: MODULE_ROUTE.DEPARTMENT,
        icon: "👥",
        permissionCodes: ["MANAGE_DEPARTMENTS"],
      },
      {
        id: "shifts",
        title: "Lịch làm việc & Ca",
        path: MODULE_ROUTE.SHIFT,
        icon: "⏰",
        permissionCodes: [
          "VIEW_SHIFTS",
        ],
      },
      {
        id: "shift-assignment",
        title: "Gán ca cho nhân viên",
        path: MODULE_ROUTE.SHIFT_ASSIGNMENT,
        icon: "⏰",
        permissionCodes: [
          "VIEW_ASSIGN_SHIFTS" // Quyền gán ca cho nhân viên
        ],
      },
      {
        id: "fault-tickets",
        title: "Quản lý phiếu lỗi",
        path: MODULE_ROUTE.FAULT_TICKET,
        icon: "⚠️",
        permissionCodes: ["OPERATION_SUPERVISOR"],
      },
      {
        id: "adjustment-requests",
        title: "Yêu cầu điều chỉnh",
        path: MODULE_ROUTE.ADJUSTMENT_REQUEST,
        icon: "📝",
        permissionCodes: ["ADJUSTMENT_REQUEST_REVIEW"],
      },
      {
        id: "attendance-management",
        title: "Quản lý chấm công",
        path: MODULE_ROUTE.ATTENDANCE_MANAGEMENT,
        icon: "⏰",
        permissionCodes: ["ATTENDANCE_VIEW"],
      },
      {
        id: "attendance-personal",
        title: "Chấm công của tôi",
        path: MODULE_ROUTE.ATTENDANCE_PERSONAL,
        icon: "⏰",
        // Giữ mở cho mọi nhân viên (self-service)
        permissionCodes: [],
      }
      // {
      //   id: "payroll",
      //   title: "Tính lương & Thưởng",
      //   path: "",
      //   icon: "💵",
      //   permissionCodes: [],
      // },
      // {
      //   id: "training",
      //   title: "Đào tạo & Phát triển",
      //   path: "",
      //   icon: "📚",
      //   permissionCodes: [],
      // },
      // {
      //   id: "performance",
      //   title: "Đánh giá hiệu suất",
      //   path: "",
      //   icon: "📈",
      //   permissionCodes: [],
      // },
    ],
  },
  {
    id: "reports",
    title: "BÁO CÁO & PHÂN TÍCH",
    items: [
      {
        id: "report-executive",
        title: "Dashboard CEO",
        path: MODULE_ROUTE.REPORT_EXECUTIVE,
        icon: "📊",
        permissionCodes: ["REPORT_EXECUTIVE_VIEW"],
      },
      {
        id: "report-sales",
        title: "Báo cáo Doanh số",
        path: MODULE_ROUTE.REPORT_SALES,
        icon: "💰",
        permissionCodes: ["REPORT_SALES_VIEW"],
      },
      {
        id: "report-operations",
        title: "Báo cáo Vận hành",
        path: MODULE_ROUTE.REPORT_OPERATIONS,
        icon: "🔄",
        permissionCodes: ["REPORT_OPERATIONS_VIEW"],
      },
      {
        id: "report-finance",
        title: "Báo cáo Tài chính",
        path: MODULE_ROUTE.REPORT_FINANCE,
        icon: "📈",
        permissionCodes: ["REPORT_FINANCE_VIEW"],
      },
      {
        id: "report-marketing",
        title: "Báo cáo Marketing",
        path: MODULE_ROUTE.REPORT_MARKETING,
        icon: "🎯",
        permissionCodes: ["REPORT_MARKETING_VIEW"],
      },
      {
        id: "employee-kg-report",
        title: "Báo cáo sản lượng",
        path: MODULE_ROUTE.EMPLOYEE_KG_REPORT,
        icon: "⚖️",
        permissionCodes: ["EMPLOYEE_KG_REPORT_VIEW"],
      },
      {
        id: "sales-output-report",
        title: "Báo cáo xuất bán",
        path: MODULE_ROUTE.SALES_OUTPUT_REPORT,
        icon: "🧾",
        permissionCodes: ["SALES_OUTPUT_REPORT_VIEW"],
      },
      {
        id: "fault-ticket-report",
        title: "Báo cáo phiếu lỗi",
        path: MODULE_ROUTE.FAULT_TICKET_REPORT,
        icon: "⚠️",
        permissionCodes: ["FAULT_TICKET_REPORT_VIEW"],
      },
      {
        id: "reconciliation-report",
        title: "Đối soát khách hàng",
        path: MODULE_ROUTE.RECONCILIATION_REPORT,
        icon: "⚖️",
        permissionCodes: ["RECONCILIATION_REPORT_VIEW"],
      },
      {
        id: "item-debt-overview-report",
        title: "Đối soát đơn hàng",
        path: MODULE_ROUTE.ITEM_DEBT_OVERVIEW_REPORT,
        icon: "📊",
        permissionCodes: ["ITEM_DEBT_OVERVIEW_REPORT_VIEW"],
      },
      {
        id: "rewash-report",
        title: "Báo cáo hàng Re-wash",
        path: MODULE_ROUTE.REWASH_REPORT,
        icon: "🔁",
        permissionCodes: ["REWASH_REPORT_VIEW"],
      },
    ],
  },
  {
    id: "permission",
    title: "QUẢN TRỊ PHÂN QUYỀN",
    items: [
      {
        id: "permission-department", // Đã sửa id từ "users"
        title: "Phân quyền theo bộ phận",
        path: MODULE_ROUTE.PERMISSION_DEPARTMENT,
        icon: "👥",
        // permissionCodes: [], // Dùng tên route
        permissionCodes: ["PERMISSION_DEPARTMENT_VIEW"], // Dùng tên route
      },
      {
        id: "permission-employee", // Đã sửa id từ "users"
        title: "Phân quyền theo người dùng",
        path: MODULE_ROUTE.PERMISSION_EMPLOYEE,
        icon: "👤",
        // permissionCodes: [], // Dùng tên route
        permissionCodes: ["PERMISSION_EMPLOYEE_VIEW"], // Dùng tên route
      },
    ]  
  },
  {
    id: "system",
    title: "QUẢN TRỊ HỆ THỐNG",
    items: [
      // Ẩn: đã có Phân quyền theo bộ phận + Phân quyền theo người dùng
      // {
      //   id: "users",
      //   title: "Người dùng & Phân quyền",
      //   path: MODULE_ROUTE.PRIVILEGE,
      //   icon: "👤",
      //   permissionCodes: ["USERS_VIEW"],
      // },
      {
        id: "system-settings",
        title: "Cài đặt hệ thống",
        path: MODULE_ROUTE.SETTING,
        icon: "⚙️",
        permissionCodes: ["SYSTEM_SETTINGS_VIEW"], // Thêm permission code
      },
      {
        id: "branch-settings",
        title: "Cài đặt chi nhánh",
        path: MODULE_ROUTE.BRANCH_SETTINGS,
        icon: "🏢",
        permissionCodes: ["BRANCH_SETTINGS_VIEW"],
      },
      {
        id: "setting-payment-method",
        title: "Cài đặt phương thức thanh toán",
        path: MODULE_ROUTE.SETTING_PAYMENT_METHOD,
        icon: "💳",
        permissionCodes: ["PARTNER_MANAGEMENT"],
      },
      // "Cấu hình tài xế" đã gộp vào "Cài đặt hệ thống" (thời gian chờ xác nhận + tần suất nhắc nhở).
      // {
      //   id: "integrations",
      //   title: "Tích hợp & API",
      //   path: "",
      //   icon: "🔗",
      //   permissionCodes: ["INTEGRATIONS_VIEW"],
      // },
      // {
      //   id: "backup",
      //   title: "Sao lưu & Phục hồi",
      //   path: "",
      //   icon: "💾",
      //   permissionCodes: ["BACKUP_VIEW"],
      // },
      // {
      //   id: "audit-logs",
      //   title: "Nhật ký hệ thống",
      //   path: "",
      //   icon: "📋",
      //   permissionCodes: ["AUDIT_LOGS_VIEW"],
      // },
      // {
      //   id: "security",
      //   title: "Bảo mật & Giám sát",
      //   path: "",
      //   icon: "🔒",
      //   permissionCodes: ["SECURITY_VIEW"],
      // },
    ],
  },
];